import { I18n } from 'i18n-js';
import en from './locales/en/translation.json';
import bn from './locales/bn/translation.json';

// Initilize I18n instance
const i18n = new I18n();

// Set translations
i18n.translations = {
  en,
  bn,
};

i18n.fallbacks = true;
i18n.defaultLocale = 'en';
i18n.locale = 'en';

// i18n-js uses %{} by default, but let's set it explicitly
i18n.interpolation = {
  prefix: '%{',
  suffix: '}',
  // Enable nested translations
  nestingEnabled: true,
  // Add default values for missing translations
  defaultVariables: {},
};

// Set missing translation behavior
i18n.missingBehaviour = 'guess';
i18n.missingTranslationPrefix = '[missing "';
i18n.missingTranslationSuffix = '" translation]';

export default i18n;
